import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { HopperListingModel, HopperStatus, HopperListingPayload } from './model'
import { ListingsValidationFieldResult } from '../rental-validation-field'

@Injectable({
  providedIn: 'root',
})
export class HopperChannelService {
  constructor(private http: HttpClient) {}

  connect(payload: { email: string; name: string }) {
    const url = `@api/hopper/connection/connect`

    return this.http.post(url, payload)
  }

  getStatus() {
    const url = `@api/hopper/connection/status`

    return this.http.get<HopperStatus>(url)
  }

  disconnect() {
    const url = `@api/hopper/connection/disconnect`

    return this.http.post(url, {})
  }

  activateListing(listingId: string) {
    const url = `@api/hopper/listings/${listingId}/status`

    return this.http.put(url, { active: true })
  }

  deactivateListing(listingId: string) {
    const url = `@api/hopper/listings/${listingId}/status`

    return this.http.put(url, { active: false })
  }

  getListings() {
    const url = `@api/hopper/listings`

    return this.http.get<HopperListingModel[]>(url)
  }

  createListing(listing: HopperListingPayload) {
    const url = `@api/hopper/listings`

    return this.http.post<HopperListingModel>(url, listing)
  }

  updateListing(listing: HopperListingPayload) {
    const url = `@api/hopper/listings`

    return this.http.post<HopperListingModel>(url, listing)
  }

  getRentalValidations() {
    const url = `@api/hopper/listings/validate/rentals`

    return this.http.post<ListingsValidationFieldResult>(url, {})
  }
}
